<img
  [attr.alt]="country | translateCountry"
  [matTooltip]="country | translateCountry"
  [matTooltipDisabled]="!showTooltip"
  [src]="flagUrl" />
@if (showLabel) {
  <p class="country-name">{{ country | translateCountry }}</p>
}
